var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiscountsEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 226,
    viewBox: "0 0 226 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.5 187c40.869 0 74-33.131 74-74 0-40.87-33.131-74-74-74-40.87 0-74 33.13-74 74 0 40.869 33.13 74 74 74z",
    fill: "#F0F1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 127l26.8-95.6c.8-2.8 2.7-5.1 5.2-6.4l-8 83.6-18 20.4-6-2z",
    fill: "#828A91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.3 131.7c.5-1.6-.1-3.3-1.5-4.4l-5.3-3.5c-.7-.5-1.6-.8-2.4-.8-1.6 0-3.1 1-3.7 2.4L85.1 149c-1.7 3.9-4.6 7-8.3 9-1.3.7-2.8 1.2-4.2 1.6-8.6 2.3-14.8 10.6-13.9 20.1.8 8.7 7.7 15.9 16.4 17 8.2 1 15.6-3.2 19.1-9.7l4.1-6.4c1.4-2.2 1.3-4.9-.1-7.1-1.1-1.6-1.4-3.5-.8-5.4l10.9-36.4zM77.5 191c-7.2 0-13-5.8-13-13s5.8-13 13-13 13 5.8 13 13-5.8 13-13 13z",
    fill: "#399C97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 39h-110v62h110V39z",
    fill: "#E9AF58"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.5 47h-94v46h94V47z",
    fill: "#D9942D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124 56h-3v4h3v-4zm0 8h-3v4h3v-4zm0 8h-3v4h3v-4zm0 8h-3v4h3v-4zm0-33h-3v5h3v-5zm0 41h-3v5h3v-5zM76.9 61.4c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0l-20 20c-.8.8-.8 2 0 2.8.8.8 2 .8 2.8 0l20-20zm-19.4 6.1c-3 0-5.5-2.5-5.5-5.5s2.5-5.5 5.5-5.5S63 59 63 62s-2.5 5.5-5.5 5.5zm0-8c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5S60 63.4 60 62s-1.1-2.5-2.5-2.5zm16 24c-3 0-5.5-2.5-5.5-5.5s2.5-5.5 5.5-5.5S79 75 79 78s-2.5 5.5-5.5 5.5zm0-8c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5S76 79.4 76 78s-1.1-2.5-2.5-2.5z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.5 127L97.7 31.4c-.8-2.8-2.7-5.1-5.2-6.4l8 83.6 18 20.4 6-2z",
    fill: "#D2D5D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7 34.5l17.4 62.2c.6 2.2 2.6 3.8 4.9 3.8l-19.3-69c-.8-2.9-2.7-5.2-5.2-6.5l.6 6.1c.7 1 1.3 2.2 1.6 3.4z",
    fill: "#E8E9EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 111a3 3 0 100-6 3 3 0 000 6z",
    fill: "#828A91"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.5 160.7c-1.5-.4-2.9-.9-4.2-1.6-3.7-2-6.7-5.2-8.3-9l-10.3-23.6c-.8-1.5-2.2-2.5-3.8-2.5-.9 0-1.7.3-2.4.8l-5.3 3.5c-1.3 1-1.9 2.7-1.5 4.4l11 36.4c.5 1.8.2 3.8-.8 5.4-1.4 2.1-1.5 4.9-.1 7.1l2.6 4.1c2.1-.4 4.2-.9 6.2-1.5-.7-1.6-1.1-3.4-1.1-5.2 0-7.2 5.8-13 13-13 5 0 9.3 2.8 11.5 6.9 1.6-1.2 3.2-2.4 4.7-3.8-2.5-4.1-6.5-7.1-11.2-8.4z",
    fill: "#108060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountsEmptyState);
export default __webpack_public_path__ + "static/media/discounts-empty-state.7a6e434b6697415172cb3c0217823710.svg";
export { ForwardRef as ReactComponent };